import { EventBus } from '@/event'
import { mVMixin } from '@/mixins'
export const process = {
    state: {
        auth: `Bearer ${localStorage.getItem('token')}`
    },
    actions: {
        listPreProcessJobs(context, data) {
            let myHeaders = new Headers()
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            myHeaders.append('Authorization', `Bearer ${token}`)
            let requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            }
            EventBus.$emit('Loader', true)
            let params = `${mVMixin.methods.getParam(data)}`
            return new Promise((resolve, reject) => {
                fetch(`${context.getters.getbaseUrl}provider/v1/preprocess?${params}`, requestOptions)
                    .then((response) => {
                        if (response.ok) {
                            resolve(response.json())
                        } else {
                            resolve(response.json())
                        }
                        EventBus.$emit('Loader', false)

                    }).catch(error => {
                        EventBus.$emit('Loader', false)

                        reject(error)
                    })
            })
        },
        updatePreProcessFiles(context, data) {
            let myHeaders = new Headers()
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            myHeaders.append('Authorization', `Bearer ${token}`)
            myHeaders.append('Content-Type', 'application/json')
            let requestOptions = {
                method: 'PUT',
                headers: myHeaders,
                body: JSON.stringify(data.formdata)
            }
            EventBus.$emit('Loader', true)
            return new Promise((resolve, reject) => {
                fetch(`${context.getters.getbaseUrl}provider/v1/preprocess/${data.preprocessid}`, requestOptions)
                    .then(response => {
                        EventBus.$emit('Loader', false)
                        if (response.ok) {
                            // console.log('inapiedit', response.json())
                            resolve(response.json())
                        } else {
                            resolve(response.json())
                        }
                    }).catch(error => {
                        EventBus.$emit('Loader', false)
                        reject(error)
                    })
            })
        },
        getUnprocessedList(context, data) {
            let myHeaders = new Headers()
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            myHeaders.append('Authorization', `Bearer ${token}`)
            myHeaders.append('Content-Type', 'application/json')
            let requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            }
            EventBus.$emit('Loader', true)
            return new Promise(function(resolve, reject) {
                fetch(`${context.getters.getbaseUrl}provider/v1/preprocess/unprocessed?originalfilename=${data.originalfilename}&filetype=${data.filetype}&contenttype=${data.contenttype}&todate=${data.todate}&fromdate=${data.fromdate}&page=${data.page}&pagesize=${data.pagesize}`, requestOptions)
                    .then(response => {
                        EventBus.$emit('Loader', false)
                        if (response.ok) {
                            resolve(response.json())
                        } else {
                            resolve(response.json())
                        }
                    }).catch(error => {
                        EventBus.$emit('Loader', false)
                        reject(error)
                    })
            })
        },
        preprocessFiles(context, data) {
            let myHeaders = new Headers()
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            myHeaders.append('Authorization', `Bearer ${token}`)
            let requestOptions = {
                headers: myHeaders,
                method: 'POST',
                body: data
            }
            EventBus.$emit('Loader', true)
            return new Promise(function(resolve, reject) {
                fetch(`${context.getters.getbaseUrl}provider/v1/preprocess`, requestOptions)
                    .then(response => {
                        EventBus.$emit('Loader', false)
                        if (response.ok) {
                            resolve(response.json())
                        } else {
                            resolve(response.json())
                        }
                    }).catch(error => {
                        EventBus.$emit('Loader', false)
                        reject(error)
                    })
            })
        },
    }
}


// WEBPACK FOOTER //
// ./src/store/process.js